export default __webpack_public_path__ + "static/media/oranges.9a6aab77.jpg";